import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { CreateProgressCheckPdfScreenPath } from "./paths.ts";

export function useToCreateProgressCheckPdfScreen() {
  const navigate = useNavigate();

  const toCreate = useCallback(() => {
    navigate(CreateProgressCheckPdfScreenPath);
  }, [navigate]);

  return {
    toCreate,
  };
}
